import React, { FC } from 'react';
import { Box, Typography } from '@mui/material';
import theme from 'src/e2e-redesign/theme';
import { styled } from '@mui/material/styles';

const StyledPageIntro = styled(Box)(({ theme }) => ({
  padding: `${theme.spacing(2)} ${theme.spacing(2)} ${theme.spacing(2)} 0`,
  backgroundColor: '#ffffff',
}));

interface PageIntroProps {
  title: string;
  paragraph?: string;
  disclaimer?: string;
}

const PageIntro: FC<PageIntroProps> = ({ title, paragraph, disclaimer }) => {
  return (
    <StyledPageIntro>
      <Typography sx={{ color: theme.palette.primary.main }} variant="h1" component="h1" gutterBottom>
        {title}
      </Typography>
      {disclaimer && (
        <Typography variant="body1" paragraph sx={{ mb: 2 }}>
          {disclaimer}
        </Typography>
      )}
      {paragraph && (
        <Typography variant="body1" paragraph mt={2}>
          <div dangerouslySetInnerHTML={{ __html: paragraph }} />
        </Typography>
      )}
    </StyledPageIntro>
  );
};

export default PageIntro;
